import { createContext, useContext } from "react";

export type DesignContextType = {
  anchorBlock?: {
    verticalLine?: string | string[];
    summaryItem?: string | string[];
    container?: string | string[];
  };
  authorProfile?: {
    verticalLine?: string | string[];
    link?: string | string[];
  };
  button?: {
    primary?: string | string[];
    secondary?: string | string[];
    tertiary?: string | string[];
  };
  callBlock?: {
    verticalLine?: string | string[];
    horizontalLine?: string | string[];
  };
  divider?: {
    secondary?: string | string[];
  };
  figureCaptions?: {
    imageCaption?: string | string[];
  };
  heading?: {
    headingBase?: string | string[];
    headingSplit?: string | string[];
  };
  sectionHeading?: {
    container?: string | string[];
  };
  homeContentBlockB?: {
    contentBlockContainer?: string | string[];
    contentBlockScroll?: string | string[];
  };
  homeContentBlockF?: {
    sectionHeading?: string | string[];
    itemsContainer?: string | string[];
    anchorBlock?: string | string[];
  };
  homeContentBlockG?: {
    sectionHeading?: string | string[];
  };
  magazineListing?: {
    border?: string | string[];
    divider?: string | string[];
    verticalLine?: string | string[];
    carouselContent?: string | string[];
  };
  navLinks?: {
    verticalLineHeader?: string | string[];
    verticalLineFooter?: string | string[];
    itemLink?: string | string[];
  };
  relatedItem?: {
    verticalLine?: string | string[];
    firstItem?: string | string[];
  };
  stickyTitle?: {
    font?: string | string[];
  };
  textLink?: string | string[];
  videoGallery?: {
    verticalLine?: string | string[];
  };
  videoOverlay?: {
    playIcon?: string | string[];
  };
  categoryLayout?: {
    sectionContainer?: string | string[];
    infoContainer?: string | string[];
    anchorBlock?: string | string[];
    tabContainer?: string | string[];
    categoryHeading?: string | string[];
    mainContent?: {
      item?: string | string[];
    };
    exploreMoreContainer?: string | string[];
  };
  navbar?: {
    primaryItems?: string | string[];
    logo?: string | string[];
    articleSection?: string | string[];
    dropDown?: string | string[];
  };
  contentHubLayout?: {
    userSubmissionBox?: string | string[];
    articleMastHeadText?: string | string[];
    standfirst?: string | string[];
    primaryContentSection?: string | string[];
    contentBlockListingContainer?: string | string[];
  };
  label?: string | string[];
  tags?: {
    wrapper?: string | string[];
    primary?: string | string[];
    secondary?: string | string[];
  };
  contentBlock?: {
    cta?: string | string[];
  };
  homeAnchorBlock?: string | string[];
  latestArticle?: {
    landscape?: string | string[];
    container?: string | string[];
  };
  errorLayout?: {
    container?: string | string[];
    errorLayoutHeadingContainer?: string | string[];
  };
  aboutUs?: {
    heading?: string | string[];
    standfirst?: string | string[];
    storylineContainer?: string | string[];
    authorBlockContainer?: string | string[];
    headingTextContainer?: string | string[];
  };
  singlePost?: {
    readmore?: string | string[];
  };
  socialIcons?: {
    footerContainer?: string | string[];
    megaMenuContainer?: string | string[];
    socialMedialink?: string | string[];
  };
  socialMedia?: {
    container?: string | string[];
    altContainer?: string | string[];
  };
  megaMenu?: {
    columnItem?: string | string[];
    details?: string | string[];
    summary?: {
      container?: string | string[];
      buttonItem?: string | string[];
    };
  };
  subAnchor?: {
    item?: string | string[];
  };
  homeLatestArticle?: {
    container?: string | string[];
    item?: string | string[];
  };
  homeContentBlockD?: {
    container?: string | string[];
    item?: string | string[];
    altStyleContainer?: string | string[];
    itemContainerAltStyle?: string | string[];
    scroll?: string | string[];
  };
  homeGrid?: {
    mainSectionContainer?: string | string[];
    container?: string | string[];
  };
  homeContentBlockJ?: {
    mainSectionContainer?: string | string[];
    itemsContainer?: string | string[];
  };
  tagLayout?: {
    headingContainer?: string | string[];
  };
  affiliateShopping?: {
    blockContainer?: string | string[];
  };
};

const CustomClassContext = createContext<DesignContextType | null>(null);

const useCustomClassContext = () => useContext(CustomClassContext);

export { useCustomClassContext, CustomClassContext };
